import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ProtectionUserKernelInterrupts = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Protection: User/Kernel Modes & Interrupts"
    videos={[
      "https://www.youtube.com/embed/8duV1LLHHJU",
      "https://www.youtube.com/embed/K8p9KxuzZ-U"
    ]}
    takeaways={[]}
    questions={[
      "Categorize the following instructions into privileged instructions and non-privileged instructions. Also mention whether the instruction to be executed under user mode or kernel mode. i) Reading system time ii) Clear Memory iii) Opening and reading a file iv) Set the timer v) Performing arithmetic operation",
      "What are the functions of Kernel? Discuss on kernel design and its interface role for user handling with an example"
    ]}
    exampleVideos={[]}
  />
);
}

export default ProtectionUserKernelInterrupts;
